/*!
 * @pixi/filter-multi-color-replace - v5.1.1
 * Compiled Fri, 24 Mar 2023 22:12:11 UTC
 *
 * @pixi/filter-multi-color-replace is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */import{Filter as m,utils as a}from"@pixi/core";var c=`attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`,g=`varying vec2 vTextureCoord;
uniform sampler2D uSampler;

uniform float epsilon;

const int MAX_COLORS = %maxColors%;

uniform vec3 originalColors[MAX_COLORS];
uniform vec3 targetColors[MAX_COLORS];

void main(void)
{
    gl_FragColor = texture2D(uSampler, vTextureCoord);

    float alpha = gl_FragColor.a;
    if (alpha < 0.0001)
    {
      return;
    }

    vec3 color = gl_FragColor.rgb / alpha;

    for(int i = 0; i < MAX_COLORS; i++)
    {
      vec3 origColor = originalColors[i];
      if (origColor.r < 0.0)
      {
        break;
      }
      vec3 colorDiff = origColor - color;
      if (length(colorDiff) < epsilon)
      {
        vec3 targetColor = targetColors[i];
        gl_FragColor = vec4((targetColor + colorDiff) * alpha, alpha);
        return;
      }
    }
}
`;class h extends m{constructor(o,i=.05,e=o.length){super(c,g.replace(/%maxColors%/g,e.toFixed(0))),this._replacements=[],this._maxColors=0,this.epsilon=i,this._maxColors=e,this.uniforms.originalColors=new Float32Array(e*3),this.uniforms.targetColors=new Float32Array(e*3),this.replacements=o}set replacements(o){const i=this.uniforms.originalColors,e=this.uniforms.targetColors,l=o.length;if(l>this._maxColors)throw new Error(`Length of replacements (${l}) exceeds the maximum colors length (${this._maxColors})`);i[l*3]=-1;for(let r=0;r<l;r++){const s=o[r];let n=s[0];typeof n=="number"?n=a.hex2rgb(n):s[0]=a.rgb2hex(n),i[r*3]=n[0],i[r*3+1]=n[1],i[r*3+2]=n[2];let t=s[1];typeof t=="number"?t=a.hex2rgb(t):s[1]=a.rgb2hex(t),e[r*3]=t[0],e[r*3+1]=t[1],e[r*3+2]=t[2]}this._replacements=o}get replacements(){return this._replacements}refresh(){this.replacements=this._replacements}get maxColors(){return this._maxColors}set epsilon(o){this.uniforms.epsilon=o}get epsilon(){return this.uniforms.epsilon}}export{h as MultiColorReplaceFilter};
//# sourceMappingURL=filter-multi-color-replace.mjs.map
